import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    font-size: 12px
  }
   body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    //background-color: #eff1f5;
  }
   input.form-control.disabled {
       border-color: #d9d9d9;
       -webkit-box-shadow: 0 0 0 62.5rem #f5f5f5 inset !important;
       color: rgba(0, 0, 0, 0.25) !important;
   }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance:textfield;
  }

  // scrollbar
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Sidebar 디자인 변경 관련 주석 처리
  ::-webkit-scrollbar-track-piece {
    background-color: white;
  }
  */

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: darkgray;
  }

  /* common classes */
  .main {
    padding: 10px;
  }

  /*
  .content {
    min-width: 1200px;
  }
  */

  .hidden {
    display: none;
  }

  .pointer {
    cursor: pointer;
  }
  
  .canceled-row {
    background-color: rgb(230, 230, 230);
    cursor: pointer;
  }
  
  .cursor-default {
    cursor: default;
  }

  .chosen {
    background: bisque;
  }

  .transition {
    transition: all 0.3s ease-in-out;
  }
  
  .box-photo {
    width: 120px;
    height: 120px;
    background: url('/images/bg-photo.png') no-repeat center center;
    background-color: #e9e6e7;
    border: 1px solid #e9e6e7;
    border-radius: 5px;
    display: flex;
    justify-content: center;
  }

  .print {
    #map {
      // width: 800px;
      // height: 500px;
      // position: relative;
      // top: 10px;
      // left: 10px;
      @page { size: landscape; }
    }
  }

  .download-link,
  .click-link {
    text-decoration: underline;
    color: black;
    cursor: pointer;
  }

  .post-link {
    cursor: pointer;
  }

  .post-link:hover {
    text-decoration: underline;
  }

  .text-underline {
    text-decoration: underline;
  }

  .check-result {
    font-size: 13px;
  }

  .radio-wrapper {
    label {
      width: 60px;
    }
  }

  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .align-middle {
    vertical-align: middle;
  }

  /* font-weight */
  .fw-600 {
    font-weight: 600;
  }

  .fw-700 {
    font-weight: 700;
  }

  /* sizing */
  .w-60p {
    width: 60px;
  }

  .w-80p {
    width: 80px;
  }

  .w-90p {
    width: 90px;
  }

  .w-100p {
    width: 100px;
  }

  .w-110p {
    width: 110px;
  }

  .w-120p {
    width: 120px;
  }

  .w-150p {
    width: 150px;
  }
  
  .w-210p {
    width: 210px;
  }

  .w-240p {
    width: 240px;
  }

  .w-100vw {
    min-width: 0;
    width: 100vw;
  }

  .max-w1200p {
    max-width: 1200px;
  }

  .v-line {
    position: relative;
    top: 5px;
  }

  .pr-t1 {
    position: relative;
    top: 1px;
  }

  .pr-t5 {
    position: relative;
    top: 5px;
  }

  .pr-t10 {
    position: relative;
    top: 10px;
  }

  .pr-t20 {
    position: relative;
    top: 20px;
  }

  .mr-p7d5 {
    margin-right: 7.5px;
  }

  /* flex */
  .flex {
    display: flex
  }

  .flex-justify-start {
    justify-content: flex-start;
  }

  .flex-justify-center {
    justify-content: center;
  }

  .flex-justify-end {
    justify-content: flex-end;
  }

  .flex-justify-between {
    justify-content: space-between;
  }

  .flex-justify-around {
    justify-content: space-around;
  }

  .flex-align-center {
    align-items: center;
  }

  .flex-align-end {
    align-items: end;
  }

  /* table */
  .table-basic {
    th, td {
      padding-top: 5px;
      padding-bottom: 5px;
    }

    th {
      background: ghostwhite;
    }
  }

  .table-contrast {
    th, td {
      padding-top: 5px;
      padding-bottom: 5px;
      border: 1px solid gainsboro;
      text-align: center;
    }

    th {
      background: black;
      color: white;
    }
  }

  .table-edit {
    margin: 0 10px 10px 10px;
    border-collapse: collapse;
    border-top: 2px solid #bb0665;

    th, td {
      height: 60px;
      padding: 10px;
      border-bottom: 1px solid gainsboro;
    }

    th {
      width: 10%;
      background: #e7e7e7;
    }

    td {
      background: #ffffff;
    }    

    .input-text {
      width: 100%;
    }

    label {
      width: 70px;
    }
  }

  .ant-descriptions-view table {
    width: 100%;
    table-layout: fixed;
    /* border-top: 2px solid #bb0665; */
  }

  .table-detail {
    margin-bottom: 10px;

    th, td {
      padding: 10px;
      border: 1px solid gainsboro;
    }

    th {
      background: darkgray;
    }
  }

  .table-tab {
    th, td {
      padding-top: 5px;
      padding-bottom: 5px;
      border: 1px solid gainsboro;
    }

    th {
      background: white;
    }

    th.selected {
      background: darkgray;
    }
  }

  .table-row-bg {
    background-color: #ddd;
  }

  /* ant design */
  .ant-descriptions-view table {
    width: 100%;
    table-layout: fixed;
    /*border-top: 2px solid #bb0665; */
    /*border-top: 1px solid #2e4052; */
    margin-bottom: 0px !important;
  }

  .ant-modal-footer {
    padding: 15px 16px;
    text-align: center;
    background: transparent;
    border-top: 1px solid #f0f0f0;
    border-radius: 0 0 2px 2px;

    button {
      width: 120px;
    }
  }

  .ant-modal-title {
    margin: 0;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    word-wrap: break-word;
  }

  .ant-picker {
    height: 28px;
  }

  .ant-picker-dropdown {
    z-index: 99999;
  }

  .ant-picker-time-panel-cell-disabled {
    display: none;
  }

  .ant-table table {
    width: 100%;
    text-align: left;
    border-radius: 2px 2px 0 0;
    border-collapse: separate;
    border-spacing: 0;
    /* border-top: 2px solid #999; */
    margin-top: 0px;
  }

  .ant-table-wrapper {

    .ant-table-pagination {
      display: none;
    }
  }
  
  .ant-btn-loading-icon {
      color: #bc216d;
  }
  
  .ant-btn-loading-icon > img {
      display: flex;
      align-items: center;
  }

  .ant-table-center {
    .ant-table-cell {
      text-align: center;
    }
  }
  
  button[ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {
    content: none;    
  }

  .color-picker {
    position: fixed;
  }

  .b-color-showUp {
    background-color: rgba(187, 6, 101, 0.05);
  }
  /* Custom */
  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 800;
  }

  .card-body.table-wrapper,
  .inside-table-wrapper {
    margin-top: -15px;
  }

  .tab-table-wrapper {
    margin-top: -25px;
  }

  .table-custom {
    width: 100%;
    border-collapse: collapse;
    background-color: #ffffff;
  }

  .table:not(.table-dark) {
    color: inherit;
    background-color: #ffffff;
  }

  .table-detail {
    margin-bottom: 10px;
    background-color: #ffffff;
    border-top: 2px solid #bb0665;
  }

  .table-detail th {
    background: #e7e7e7;
  }

  .nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #bb0665;
    background-color: #007bff;
  }

  .nav-sidebar>.nav-item {
    margin-bottom: 0;
    margin-top: 5px;
    border-bottom: 1px solid #eaeaea;
  }

  .rbc-today {
    background: #f9f9f9!important; ;
  }

  .table:not(.table-dark) {
    color: inherit;
    background-color: #ffffff;
    border-bottom: 1px solid #dee2e6;
  }

  .card-body>.table>thead>tr>td, .card-body>.table>thead>tr>th {
    border-top-width: 0;
    font-weight: bold;
  }

  .chosen {
    background: #f6f6ef;
  }

  .table td, .table th {
    padding: .75rem;
    border-top: 1px solid #dee2e6;
  }

  .btn-success:hover {
    color: white;
    background-color: #0e87c5;
    border-color: #0e87c5;
    box-shadow: none;
  }

  .container, .container-fluid, .container-lg, .container-md, .container-sm, .container-xl {
    width: 100%;
    padding-right: 7.5px;
    padding-left: 7.5px;
    margin-right: auto;
    margin-left: auto;
  }
  
  .content-wrapper {
    background-color: #eff1f5;
  }

  .menu-icon {
    margin-right: 5px;
    width: 44px;
    height: 36px;
  }

  .card {
    border-top: 3px solid #990066;
    border-radius: 3px;
  }

  .card-info.card-outline {
    border-top: 3px solid #bc0665;
  }

  .card-header {
    font-weight: 500;
    color: #b8116f;
  }

  .card-footer {
    background: white;
    border-radius: 3px;
  }

  .navbar {
    padding: 0.75rem .25rem
  }

  a.nav-link {
    color: #b8116f;
  }

  .btn-primary {
    background-color: #bb0665;
    border-color: #bb0665;
  }

  .btn-secondary {
    background-color: #2e4052;
    border-color: #2e4052;
  }

  .btn-show {
    color: #fff;
    background-color: #426ee1;
    border-color: #426ee1;
  }

  .btn-show:hover {
    color: #fff;
    background-color: #3a61c6;
    border-color: #3a61c6;
  }
  
  // .btn-info {
  //   background-color: #a3acb4;
  //   border-color: #a3acb4;
  // }

  .page-item .page-link {
    color: #8891a0 !important;
  }

  .page-item.active .page-link {
    background-color: #8891a0 !important;
    border-color: #8891a0 !important;
    color: white !important;
  }

  .ant-btn-primary {
    border-color: #bc0665;
    background-color: #bc0665;
  }

  .ant-table table {
    width: 100%;
    text-align: left;
    border-radius: 2px 2px 0 0;
    border-collapse: separate;
    border-spacing: 0;
    /* border-top: 2px solid #999; */
  }

  .ant-table-thead > tr > th {
    position: relative;
    color: rgba(0,0,0,.85);
    font-weight: 500;
    text-align: left;
    background: #fafafa;
    border-bottom: 1px solid #999;
    transition: background .3s ease;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #d3d3d3;
  }

  .ant-table-tbody>tr.ant-table-row:hover>td,
  .ant-table-tbody>tr>td.ant-table-cell-row-hover {
    background: #d6eff8fh;
  }

  .table th {
    color: rgba(0,0,0,.85);
    font-weight: 500;
    background: #fafafa;
  }

  .table-row-bg {
    background-color: #f6f6ee;
  }

  .ant-descriptions-item-label,
  .ant-descriptions-item-content {
    padding: 8px !important;
  }

  .ant-descriptions-item-label {
    font-weight: 700;
  }

  .ant-descriptions-item-content {
    background-color: white;
  }

   .table-custom {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #bb0665;

    th, td {
      border: 1px solid #e9e6e7;
      padding: 8px;
    }

    th {
      background-color: #f9f9f9;
    }
  }

  .btn-success {
    color: white;
    background-color: #8ebccb;
    border-color: #8ebccb;
    box-shadow: none;
  }
  
  /* calendar */
  .rbc-month-view {
    position: relative;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    flex: 1 0;
    width: 100%;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    height: 100%;
    background-color: #3b464e;
  }

  .rbc-header {
    padding: 5px;
    background-color: #2a3139;
    color:#ffffff;
  }

  .rbc-off-range-bg {
    background: #f9f9f9;
  }

  .rbc-day-bg {
    flex: 1 0;
    background: #ffffff;
  }

  .rbc-today {
    background: #fcfbd2;
  }

  .rbc-date-cell {
    flex: 1 1;
    min-width: 0;
    padding-right: 7px;
    text-align: right;
    padding-top: 4px;
    padding-bottom: 4px;

    a {
     pointer-events: none;
     cursor: default; 
    }
  }
    
  /* dark mode */
  .dark-mode {
    background-color: #3d444b;

    *, h1 {
      color: #94a0ad;
    }

    .content-wrapper {
      background-color: #303841;
      color: #fff;
    }

    .card {
      border-top: none;
      background-color: #424e5a;
      color: #fff;
    }

    a.nav-link {
      color: gray;
    }

    .btn-secondary {
      color: #fff;
      background-color: #303841;
      border-color: #6c757d;
      box-shadow: none;
    }

    .ant-descriptions-item-content {
      background-color: #f9f9f9!important;
      border-bottom:1px solid #eaeaea!important;
    }

    .ant-descriptions-item-label {
      background-color: #E7E7EF!important;
    }

    .ant-table-thead th {
      background-color: #303841 !important;
      color: #94a0ad;
    }

    .ant-table-thead th {
      background-color: #303841 !important;
    }

    .ant-table-tbody tr {
      background-color: #424e5a !important;
    }

    .ant-table-tbody>tr.ant-table-row:hover>td,
    .ant-table-tbody>tr>td.ant-table-cell-row-hover {
      background: #66727e;
    }

    .ant-descriptions-view,
    .ant-descriptions-row,
    .ant-descriptions-item-label,
    .ant-descriptions-item-content {
      border: none;
      border-bottom: 1px solid #666666 !important;
    }

    .ant-descriptions-item-label {
      background-color: #303841 !important;
    }

    .ant-descriptions-item-content {
      background-color: #424e5a !important;
    }

    .ant-select *,
    .ant-select-dropdown * {
      color: black;
    }

    .table-bordered, .table-bordered td, .table-bordered th {
      border-color: #3a454f;
    }

    .table th {
      color: #94a0ad !important;
      background-color: #e7e7e7 !important;
    }

    .table thead th {
      border-bottom-color: #3a454f;
    }

    .table-custom {
      th {
        background-color: #303841;
      }
      td {
        background-color: #424e5a;
      }
    }

    .ant-descriptions-view table {
      width: 100%;
      table-layout: fixed;
      /* border-top: 2px solid #bb0665; */
      margin-bottom: 0px!important;
    }

    .ml-1, .mx-1 {
      margin-left: .25rem!important;
      color: #ffffff!important;
    }

    .ml-2 {
      margin-left: .5rem!important;
    }

    .mr-10 {
      margin-right: 30px;
    }

    .nav-sidebar>.nav-item {
      margin-bottom: 0;
      margin-top: 5px;
      border-bottom: 1px solid #666666;
    }

    .table-basic th, .table-basic td {
      background-color: #424e5a;
    }

    .table th {
      color: #94a0ad!important;
      background-color: #303841!important;
    }

    .card-info.card-outline {
      border-top: 2px solid #bc0665;
    }

    .border {
      border: none !important;
      border-top: 1px solid #333 !important;
      padding-top: 10px;
    }

    .table-custom th, .table-custom td {
      border: 1px solid #666666;
      padding: 8px;
      background-color: #424e5a;
    }

    .row {
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      margin-right: -7.5px;
      margin-left: -7.5px;
      margin-top: 10px;
    }
    
    .ant-table-tbody > tr > td {
      border-bottom: 1px solid #666666;
    }

    .ant-table table {
      width: 100%;
      text-align: left;
      border-radius: 2px 2px 0 0;
      border-collapse: separate;
      border-spacing: 0;
      border-top: 2px solid #bb0665;
    }

    .table-custom th, .table-custom td {
      border: 1px solid #666666;
      padding: 8px;
      background-color: #303841;
    }

    // sidebar
    .nav-sidebar>.nav-item>.nav-link.active {
      color: #fff;
    }

    .nav-sidebar>.nav-item>.nav-link.active {
      color: #fff;
      box-shadow: 0 0px 0px rgb(0 0 0 / 12%), 0 0px 0px rgb(0 0 0 / 24%);
    }

    .main-sidebar {
      background-color: #343a40;

      .nav-sidebar .nav-link p {
        color: #c2c7d0;
      }
      
      .nav-treeview {
        background-color: #2d323a !important;
      }

      // 상위 메뉴
      .nav-sidebar > .nav-item > .nav-link.active,
      .nav-sidebar > .nav-item > .nav-link:active,
      .nav-sidebar > .nav-item > .nav-link:focus {
        background-color: #2d323a;
        p {
          color: #c2c7d0;
        }
      }

      .nav-sidebar > .nav-item.menu-open > .nav-link,
      .nav-sidebar > .nav-item:hover > .nav-link {
        background-color: #2d323a;
        p {
          color: #c2c7d0;
        }
      }

      // 하위 메뉴
      .nav-treeview > .nav-item .nav-link:hover,
      .nav-treeview > .nav-item .nav-link:focus {
        background-color: #2d323a;
        p > * {
          color: #c2c7d0;
        }
      }

      .nav-treeview > .nav-item .nav-link.active,
      .nav-treeview > .nav-item .nav-link.active:hover {
        background-color: #3d444b;
        p > * {
          color: #ea4ca5;
        }
      }
    }
  }
`;

export default GlobalStyle;
